import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Compose class names, with later Tailwind utilities beating earlier ones.
 *
 * Plain concatenation leaves both `p-2` and `p-4` in the string and the winner is whichever
 * CSS rule happens to come later in the stylesheet — which is not something a caller can reason
 * about. `twMerge` resolves the conflict by intent instead.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
